var _rect, _line, _rect2, _line2, _rect3, _line3, _rect4, _line4, _rect5, _line5, _rect6, _line6, _rect7, _line7, _rect8, _line8, _rect9, _line9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTheatre(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 2.54102,
    width: 3.66666,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 1.80078,
    x2: 4.66666,
    y2: 1.80078,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8333,
    y: 2.54102,
    width: 3.66666,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 20.3333,
    y1: 1.80078,
    x2: 23,
    y2: 1.80078,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6667,
    y: 2.54102,
    width: 3.66666,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 11.1666,
    y1: 1.80078,
    x2: 13.8332,
    y2: 1.80078,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 19.3945,
    width: 3.66667,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 18.6543,
    x2: 4.66667,
    y2: 18.6543,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8335,
    y: 19.3945,
    width: 3.66667,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 20.3334,
    y1: 18.6543,
    x2: 23,
    y2: 18.6543,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6666,
    y: 19.3945,
    width: 3.66667,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 11.1666,
    y1: 18.6543,
    x2: 13.8332,
    y2: 18.6543,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 11.283,
    width: 3.66666,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: 10.543,
    x2: 4.66666,
    y2: 10.543,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8333,
    y: 11.283,
    width: 3.66666,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 20.3333,
    y1: 10.543,
    x2: 23,
    y2: 10.543,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.6667,
    y: 11.283,
    width: 3.66666,
    height: 3.60522,
    rx: 1,
    fill: "#6E6B7B"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 11.1666,
    y1: 10.543,
    x2: 13.8332,
    y2: 10.543,
    stroke: "#6E6B7B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheatre);
export default __webpack_public_path__ + "static/media/theatre.53bd83dae53842c516180d6f6450064d.svg";
export { ForwardRef as ReactComponent };